export const state = () => ({
    favoriteCartListings: {},
})

export const mutations = {
    /**
     * Sets the initial favorite state of all cart items. Triggered on cart-table mounted
     *
     * @param {object} state
     * @param {object} payload
     */
    setFavoritesList(state, payload) {
        state.favoriteCartListings = payload
    },
    /**
     * Updates a single record in the favorites Object. Used in cart components that favorite
     *
     * @param {object} state
     * @param {object} payload
     */
    updateFavoriteItem(state, payload) {
        state.favoriteCartListings = {
            ...state.favoriteCartListings,
            ...payload,
        }
    },
}
